export default class TextArea
{
  private readonly textarea: HTMLTextAreaElement;
  private readonly inputHandler: EventListener;

  constructor(textarea: HTMLTextAreaElement) {
    this.textarea = textarea;
    this.inputHandler = this.handleInputEvent.bind(this);
    this.enable();
  }

  public enable(): void
  {
    this.textarea.addEventListener('input', this.inputHandler, false);
    this.textarea.style.setProperty('resize', 'none');
    this.textarea.style.setProperty('overflow-y', 'hidden');
    this.resize();
  }

  public destroy(): void
  {
    this.textarea.removeEventListener('input', this.inputHandler);
    this.textarea.style.removeProperty('resize');
    this.textarea.style.removeProperty('overflow-y');
  }

  private handleInputEvent(event: Event): void
  {
    this.resize();
  }

  public resize()
  {
    const style = getComputedStyle(this.textarea);
    const fontSize = parseFloat(style.getPropertyValue('font-size')); // with lineheight
    const paddingTop = parseFloat(style.getPropertyValue('padding-top'));
    const paddingBottom = parseFloat(style.getPropertyValue('padding-bottom'));
    const padding = paddingTop + paddingBottom; //px
    const lineHeight = Math.ceil(parseFloat(style.getPropertyValue('line-height')));
    const minLines = parseInt(this.textarea.getAttribute('rows') ?? '3');
    const minHeight = Math.ceil(minLines * lineHeight + padding);
    this.textarea.style.minHeight = minHeight + 'px';
    
    this.textarea.style.height = 'auto';
    const lineCount = Math.ceil((Math.max(minHeight, this.textarea.scrollHeight)) / lineHeight);
    const height = Math.ceil(lineCount * lineHeight - fontSize + padding);
    this.textarea.style.height = height + "px";
  }
}